import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useMediaQuery } from 'react-responsive';
import { addRider, deleteRider, fetchRiders, fetchRider, updateRider, updateRiderProfile, getEarning } from '../apis/rider';
import { Button } from 'primereact/button';
import { TabMenu } from 'primereact/tabmenu';
import toast, { Toaster } from 'react-hot-toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
// import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import RiderFormDialog from './RiderFormDialog.tsx';

export default function Delivery() {
    const filterChange = useMediaQuery({ maxWidth: 768 });
    const [riders, setRiders] = useState([]);
    const [selectedRider, setSelectedRider] = useState(null);
    const [visible, setVisible] = useState(false);
    const [visibleEarning, setVisibleEarning] = useState(false);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [rider, setRider] = useState();
    const riderLimit = 15;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [totalEarning, setTotalEarning] = useState(null);
    const [totalOrders, setTotalOrders] = useState(null);
    const [earningRider, setEarningRider] = useState(null);
    const [isEarning, setEarning] = useState(false);
    const [riderFormVisible, setRiderFormVisible] = useState(false);
    const [riderFormLoading, setRiderFormLoading] = useState(false);
    const [riderFormMode, setRiderFormMode] = useState('create');

    const tabItems = [
        { label: 'Verified' },
        { label: 'UnVerified' },
        { label: 'Blocked' }
    ];


    const getRiders = async (page, index, limit = riderLimit) => {

        try {
            setLoading(true);

            const status = index === 0 ? 'verified' : index === 1 ? 'pending' : 'blocked';

            const riders = await fetchRiders(page, status, limit);

            if (riders.length === 0) {
                setRiders(riders);
                setTotalPage(0);
                return;
            }

            setTotalPage(parseInt(riders[0]['size']));
            setRiders(riders);

        } catch (error) {
            // setOrderError('Error fetching Orders');
            console.error("Error fetching Orders: ", error);
        } finally {
            setLoading(false);
        }

    }

    const onPage = async (event) => {
        // console.log(event);
        setFirst(event.first);
        setPage(event.page);
        try {
            await getRiders(event.page, activeIndex, riderLimit);
        } catch (error) {
            // console.log('139 - error');
            console.log(error);
        }
    };

    // const onPage = async (event) => {
    //     setFirst(event.first);
    //     getRiders(event.page);
    // };

    // const formatCurrency = (value) => {
    //     return value.toLocaleString('en-US', { style: 'currency', currency: 'INR' });
    // };

    // const priceBodyTemplate = (order) => {
    //     return formatCurrency(order.withGstprice);
    // };

    // const imageBodyTemplate = (product) => {

    //     return (
    //         <img
    //             src={`data:image/jpeg;base64,${product.image}`}
    //             alt="Product"
    //             style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '10px' }}
    //         />
    //     );
    // };

    // const statusBodyTemplate = (product) => {
    //     return <Tag value={String(product.isInstock)} severity={getSeverity(product)}></Tag>;
    // };

    // const getSeverity = (product) => {
    //     switch (String(product.isInstock)) {
    //         case 'false':
    //             return 'warning';

    //         case 'true':
    //             return 'success';

    //         default:
    //             return null;
    //     }
    // };

    // const onRowSelect = (event) => {
    //     setVisible(true);
    //     console.log('246 - row select');
    //     // getOrder(event);
    //     // toast.current.show({ severity: 'info', summary: 'Product Selected', detail: `Name: ${event.data.username}`, life: 3000 });
    // };

    // const onRowUnselect = (event) => {
    //     setVisible(false);
    //     setSelectedOrder(null);
    //     // toast.current.show({ severity: 'warn', summary: 'Product Unselected', detail: `Name: ${event.data.username}`, life: 3000 });
    // };

    useEffect(() => {
        getRiders(0, activeIndex, riderLimit);
    }, [activeIndex]);

    const getRider = async (e) => {
        try {
            const riderId = e.data['riderId'];
            setLoading(true);
            if (e.data != null) {
                const rider = await fetchRider(riderId);
                setVisible(true);
                console.log(rider);
                setRider({ ...rider, riderId });
                toast.success('Rider Fetched');
            }
        } catch (error) {
            setVisible(false);
            console.log(error);
            const errorText = error['response']['statusText'];
            toast.error(`Rider Details - ${errorText}`);
        } finally {
            setLoading(false);
        }
    }

    const openEditRider = () => {
        if (!rider?.riderId) {
            toast.error('Missing rider id');
            return;
        }

        setVisible(false);
        setRiderFormMode('edit');
        setRiderFormVisible(true);
    };

    const onRowSelect = (event) => {
        console.log('246 - row select');
        console.log(event);
        getRider(event);
    };

    const onRowUnselect = (event) => {
        setVisible(false);
        console.log(260);
        console.log(event);
    };

    const modifyRider = async (action, id) => {
        try {
            console.log(action);
            console.log(id);

            const data = await updateRider(id, action);

            console.log('184 after update rider');
            console.log(data);

            if (page > 0 && riders.length === 1) {
                await getRiders(page - 1, activeIndex, riderLimit);
            } else {
                await getRiders(page, activeIndex, riderLimit);
            }
        } catch (error) {
            toast.error('Error verifying rider');
        }
    };

    const showEarningModal = (riderId) => {
        setEarningRider(riderId);
        setVisibleEarning(true);
    }

    const getRiderEarning = async () => {
        try {
            if (startDate == null || endDate == null) {
                toast.error('Please select start and end date');
                return;
            }

            if (startDate > endDate) {
                toast.error("Start date must be before end date");
                return;
            }
            setEarning(true);

            console.log(startDate);
            console.log(endDate);

            const data = await getEarning(earningRider, startDate, endDate);

            // show dialog 

            console.log('227 after getting earning');
            console.log(data);

            if (data) {
                setTotalEarning(data.money);
                setTotalOrders(data.orders);
            }

            // if (page > 0 && riders.length === 1) {
            //     await getRiders(page - 1, activeIndex);
            // } else {
            //     await getRiders(page, activeIndex);
            // }
        } catch (error) {
            toast.error('Error fetching Earning');
        }finally{
            setEarning(false);
        }
    };

    const hideDialog = () => {
        if (!visible) return;
        setVisible(false);
        // setSelectedVendor(null);;
        setSelectedRider(null);
    }

    const hideDialogEarning = () => {
        if (!visibleEarning) return;
        setVisibleEarning(false);
        setTotalEarning(null);
        setTotalOrders(null);
        setStartDate(null);
        setEndDate(null);
    }

    const openRiderForm = () => {
        setRider(null);
        setRiderFormMode('create');
        setRiderFormVisible(true);
    };

    const hideRiderForm = () => {
        setRiderFormVisible(false);
        setRiderFormLoading(false);
    };

    const refreshRiders = async () => {
        await getRiders(page, activeIndex, riderLimit);
    };

    const submitRiderForm = async (payload) => {
        try {
            setRiderFormLoading(true);
            if (riderFormMode === 'create') {
                await addRider(payload);
                toast.success('Rider created successfully');
            } else if (rider?.riderId) {
                await updateRiderProfile(rider.riderId, payload);
                toast.success('Rider updated successfully');
            } else {
                throw new Error('Missing rider id');
            }
            setRiderFormVisible(false);
            await refreshRiders();
        } catch (error) {
            console.error(error);
            toast.error('Unable to save rider');
        } finally {
            setRiderFormLoading(false);
        }
    };

    const handleDeleteRider = async () => {
        try {
            if (!rider?.riderId) {
                toast.error('Missing rider id');
                return;
            }

            const confirmed = window.confirm('Delete this rider? This action cannot be undone.');
            if (!confirmed) {
                return;
            }

            setLoading(true);
            await deleteRider(rider.riderId);
            toast.success('Rider deleted successfully');
            setVisible(false);
            setRider(null);
            await refreshRiders();
        } catch (error) {
            console.error(error);
            toast.error('Unable to delete rider');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* <div style={{ display: 'flex', flexDirection: 'column' }} className="card h-screen overflow-auto flex-1"> */}
            <Toaster />
            <div className="card">
                {/* <h2 style={{ marginBlock: '1rem' }}>All Riders</h2> */}
                {/* <Toast ref={toast} /> */}
                <TabMenu
                    model={tabItems}
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                    pt={{
                        menu: { className: 'gap-2 mb-2' } // Tailwind: adds space between items
                    }}
                />
                <div className="flex justify-content-end mb-3">
                    <Button
                        icon="pi pi-plus"
                        label="Add Rider"
                        severity="success"
                        onClick={openRiderForm}
                    />
                </div>
                {/* <div className='flex-1'> */}
                <DataTable value={riders} lazy paginator rows={riderLimit} totalRecords={totalPage} first={first} onPage={onPage} loading={loading} loadingIcon="pi pi-spin pi-cog" emptyMessage={!loading ? `No Riders found` : null} tableStyle={{ minWidth: '50rem' }} selection={selectedRider} onSelectionChange={(e) => {
                    setSelectedRider(e.value);
                    // getOrder(e);
                    console.log(e);
                }}

                    onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} scrollable scrollHeight={filterChange ? '60vh' : '80vh'} paginatorTemplate="PrevPageLink NextPageLink CurrentPageReport"
                    currentPageReportTemplate="Total Riders: {totalRecords}">
                    <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="phoneNumber" header="Phone Number"></Column>
                    <Column field="email" header="Email"></Column>
                    {activeIndex === 0 && (
                        <Column
                            header="Earning"
                            body={(rowData) => (
                                <Button
                                    icon="pi pi-dollar"
                                    label="Show Earning"
                                    tooltip="Show earning of this rider"
                                    size="small"
                                    severity="success"
                                    onClick={() => showEarningModal(rowData.riderId)}
                                />
                            )}
                        />
                    )}
                    {/* <Column header="Earning" body={(rowData) => (
                        activeIndex === 0
                            ?
                            <Button icon="pi pi-ban" label="Block" tooltip='Block this rider' size='small' severity='danger' onClick={() => modifyRider('blocked', rowData.riderId)} />
                            : <></>
                        // activeIndex === 1 ?
                        //     <Button icon="pi pi-check" label="Verify" tooltip='Verify this rider' size='small' severity="success" onClick={() => modifyRider('verified', rowData.riderId)} />
                        //     :
                        //     <Button icon="pi pi-check" label="Un-Block" tooltip='Unblock this rider' size='small' severity="success" onClick={() => modifyRider('verified', rowData.riderId)} />
                    )} /> */}
                    <Column header="Action" body={(rowData) => (
                        activeIndex === 0
                            ?
                            <Button icon="pi pi-ban" label="Block" tooltip='Block this rider' size='small' severity='danger' onClick={() => modifyRider('blocked', rowData.riderId)} />
                            :
                            activeIndex === 1 ?
                                <Button icon="pi pi-check" label="Verify" tooltip='Verify this rider' size='small' severity="success" onClick={() => modifyRider('verified', rowData.riderId)} />
                                :
                                <Button icon="pi pi-check" label="Un-Block" tooltip='Unblock this rider' size='small' severity="success" onClick={() => modifyRider('verified', rowData.riderId)} />
                    )} />
                </DataTable>
            </div>
            <Dialog
                header="Rider Info"
                visible={visible}
                onHide={hideDialog}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                {
                    rider ?
                        <div className="p-d-flex p-ai-center">
                            <div>
                                <p><strong>Name:</strong> {rider.name}</p>
                                <p><strong>Email:</strong> {rider.email}</p>
                                <p><strong>Phone Number:</strong> {rider.phoneNumber}</p>
                                <p><strong>Aadhar Number:</strong> {rider.aadharNumber}</p>
                                <p><strong>PAN Number:</strong> {rider.panNumber}</p>
                                <p><strong>Status:</strong> {rider.status}</p>
                            </div>
                        </div>
                        : <></>
                }
                <div className="flex justify-content-end gap-2 mt-4">
                    <Button label="Edit Rider" icon="pi pi-pencil" severity="info" outlined onClick={openEditRider} type="button" />
                    <Button label="Delete Rider" icon="pi pi-trash" severity="danger" outlined onClick={handleDeleteRider} type="button" />
                </div>
            </Dialog>
            {/* <Dialog
                header="Rider Earning"
                visible={visibleEarning}
                onHide={hideDialogEarning}
                style={{ width: '50vw' }}
                className="p-fluid"
            >

            </Dialog> */}

            <Dialog
                header="Rider Earning"
                visible={visibleEarning}
                onHide={hideDialogEarning}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                <div className="p-field p-grid">
                    <label htmlFor="startDate" className="p-col-12 p-md-2">Start Date</label>
                    <div className="p-col-12 p-md-10 my-2">
                        <Calendar id="startDate" value={startDate} onChange={(e) => setStartDate(e.value)} showIcon />
                    </div>
                </div>

                <div className="p-field p-grid">
                    <label htmlFor="endDate" className="p-col-12 p-md-2">End Date</label>
                    <div className="p-col-12 p-md-10 my-2">
                        <Calendar id="endDate" value={endDate} onChange={(e) => setEndDate(e.value)} showIcon />
                    </div>
                </div>

                <div className="p-field p-grid my-3">
                    <div className="p-col-12 p-text-center">
                        <Button label="Calculate Earning" icon={`pi ${isEarning ? 'pi-spinner pi-spin' : 'pi-check'}`}
                            onClick={getRiderEarning} />
                    </div>
                </div>

                {totalEarning !== null && totalOrders !== null && (
                    <div className="p-mt-4">
                        <div className="p-field p-grid">
                            <label className="p-col-12 p-md-2">Total Earning</label>
                            <div className="p-col-12 p-md-10">
                                <InputText value={`₹${totalEarning}`} readOnly />
                            </div>
                        </div>

                        <div className="p-field p-grid">
                            <label className="p-col-12 p-md-2">Total Orders</label>
                            <div className="p-col-12 p-md-10">
                                <InputText value={totalOrders} readOnly />
                            </div>
                        </div>
                    </div>
                )}
            </Dialog>

            <RiderFormDialog
                visible={riderFormVisible}
                mode={riderFormMode}
                loading={riderFormLoading}
                onHide={hideRiderForm}
                onSubmit={submitRiderForm}
                rider={rider}
            />

        </>
    );
}
